import React from "react";

type InfoCardProps = {
    title: string;
    icon: string;
    iconAltText: string;
    description: string;
    link?: string;
    linkLabel: string;
};

const InfoCard = ({
    title,
    description,
    icon,
    iconAltText,
    link,
    linkLabel,
}: InfoCardProps) => {
    return (
        <div className="card__info">
            <div className="d-flex flex-row card__heading">
                <div className="flex-grow-1 heading__title">{title}</div>
                <div className="heading__visual">
                    <div className="heading__visual__container">
                        <img src={icon} alt={iconAltText} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="content">
                        <p
                            dangerouslySetInnerHTML={{ __html: description }}
                        ></p>
                        {!!link && (
                            <a className={"py-2"} href={link}>
                                {linkLabel}
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export { InfoCard };
